import React from "react";

const mainContextStructure = {
  username: "",
  clientName: "",
  clientId: "",
  onlyObserver: false,
}

export default React.createContext(mainContextStructure);